const WorkbenchLayout = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/WorkbenchLayout')
const WorkbenchOverview = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/WorkbenchOverview')
const WriteOffRecord = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/WriteOffRecord')
const WriteOffAllList = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/WriteOffAllList')
const CardOffRecord = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/CardOffRecord')
const PlatCouponOff = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/PlatCouponOff')
const GroupPurshareRecord = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/GroupPurshareRecord')
const StoreCouponOffRecord = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/StoreCouponOffRecord')
// const JoinPlatform = () => import(/* webpackChunkName: "workbench" */'@/components/workbench/JoinPlatform')
// const thirdList = () => import(/* webpackChunkName: "third" */'@/components/third/ThirdList')
// const thirdJoin = () => import(/* webpackChunkName: "third" */'@/components/third/ThirdJoin')
export default {
  path: 'workbench',
  component: WorkbenchLayout,
  children: [
    {
      name: 'workbenchOverview',
      path: 'overview',
      component: WorkbenchOverview,
      meta: {
        module: 'workbench',
        keepAlive: true,
      },
    },
    // 临时预约详情页面
    {
      name: 'appointment-detail',
      path: 'appointment-detail',
      component: () => import(/* webpackChunkName: "workbench" */'@/components/workbench/components/AppointmentDetail'),
      meta: {
        module: 'AppointmentDetail',
        keepAlive: true,
      },
    },
    {
      name: 'writeOffAllList',
      path: 'record',
      component: WriteOffAllList,
      meta: {
        module: 'workbench',
      },
      children: [
        {
          name: 'writeOffRecord',
          path: 'record-order',
          component: WriteOffRecord,
          meta: {
            module: 'workbench',
          },
        },
        {
          name: 'record-card',
          path: 'record-card',
          component: CardOffRecord,
          meta: {
            module: 'workbench',
          },
        },
        {
          name: 'record-coupon',
          path: 'record-coupon',
          component: StoreCouponOffRecord,
          meta: {
            module: 'workbench',
          },
        },
        {
          name: 'platCouponOff',
          path: 'platCouponOff',
          component: PlatCouponOff,
          meta: {
            module: 'workbench',
          },
        },
        {
          path: '/',
          redirect: {
            name: 'writeOffRecord',
          },
        },
      ],
    },
    {
      name: 'groupPurshareRecord',
      path: 'groupPurshareRecord',
      component: GroupPurshareRecord,
      meta: {
        module: 'workbench',
      },
    },
    // {
    //   name: 'JoinPlatform',
    //   path: 'join',
    //   component: JoinPlatform,
    //   meta: {
    //     module: 'workbench',
    //   },
    // },
    // {
    //   name: 'thirdList',
    //   path: 'thirdList',
    //   component: thirdList,
    //   meta: {
    //     module: 'workbench',
    //     // keepAlive: true,
    //   },
    // },
    // {
    //   name: 'thirdJoin',
    //   path: 'thirdList/thirdJoin',
    //   component: thirdJoin,
    //   meta: {
    //     module: 'workbench',
    //     // keepAlive: true,
    //   },
    // },
    {
      path: '/',
      redirect: {
        name: 'writeOffAllList',
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/workbench.js